export const NOT_FOUND_CODE = '404';